module.exports = __webpack_public_path__ + "static/media/debit-card.580efc9f.svg";